import { render, staticRenderFns } from "./DFASPPLeadDialog.vue?vue&type=template&id=923e4790&scoped=true"
import script from "./DFASPPLeadDialog.vue?vue&type=script&lang=js"
export * from "./DFASPPLeadDialog.vue?vue&type=script&lang=js"
import style0 from "./DFASPPLeadDialog.vue?vue&type=style&index=0&id=923e4790&prod&lang=scss"
import style1 from "./DFASPPLeadDialog.vue?vue&type=style&index=1&id=923e4790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923e4790",
  null
  
)

export default component.exports